// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZjOd","col":"styles_col__1Ej-D"};